import { DepartmentType } from '../departmentMap'
import { DepartmentRow, DepartmentTabItemType, SelectableRow } from '../types'
import { rowId } from './utils'

export const buildDepartmentTabsSection = ({
  departments,
  startIndex,
}: {
  departments: DepartmentType[]
  startIndex: number
}): { index: number; departmentRows: DepartmentRow[] } => {
  let index = startIndex
  const deptSectionId = 'department-tabs'
  const departmentRows: DepartmentRow[] = departments.map(dept => {
    const item: DepartmentTabItemType = {
      itemType: 'department',
      value: dept,
    }
    index += 1
    const row: SelectableRow = {
      id: rowId(index),
      kind: 'department',
      index,
      item,
      sectionId: deptSectionId,
    }

    return row
  })

  return { index, departmentRows }
}
